import React from 'react';
import MainFeatures from '../../components/Features';
import LeftImage from '../../components/Features/LeftImage';
import RightImage from '../../components/Features/RightImage';

const Features = () => {
  return (
    <MainFeatures
      title={
        <>
          Top <span className="text-indigo-600">Features</span> of Gmail Studio
        </>
      }
      description="What makes Email Studio an indispensible companion for your Gmail and GSuite accounts"
      link="https://emailstudio.pro"
    >
      <RightImage
        title="Send Recurring Emails &nbsp; 📨"
        image="GA17/170649.png"
        alt="Send Recurring Emails"
      >
        Send repetitive, recurring emails that go out at at custom intervals
        (daily, weekly, monthly or even hourly).
      </RightImage>
      <LeftImage
        title="Duplicate Gmail Drafts &nbsp; 📂"
        image="GA17/171055.png"
        alt="Duplicate Gmail Drafts"
      >
        Create one or more copies of an existing email draft in Gmail.
      </LeftImage>
      <RightImage
        title="Auto-Forward Emails &nbsp; 📦"
        image="GA17/171325.png"
        alt="Forward emails in Gmail"
      >
        Auto-forward your emails in Gmail to any other email address, without
        even verifying the address. You can forward old, archived emails too!
      </RightImage>
      <LeftImage
        title="Auto-Purge Emails &nbsp; 📦"
        image="GA17/172943.png"
        alt="Auto-purge emails in Gmail"
      >
        Setup rules and email messages the rule - say all emails older than 30
        days from xyz.com - will be auto-purged or marked as read and moved out
        of the Inbox!
      </LeftImage>
      <RightImage
        title="Smart Auto-Responders &nbsp; 👩🏻‍💼"
        image="GA17/172721.png"
        alt="Auto Reply to Emails"
      >
        Send smart auto-replies both old and incoming email messages. Create a
        draft in Gmail and use that as a template to respond to multiple emails.
      </RightImage>
      <LeftImage
        title="Unsubscribe from Mailing Lists &nbsp; 📦"
        image="GA17/173248.png"
        alt="Unsubscribe from Bulk Emails"
      >
        Put your bulk emails in a specific folder in Gmail and configure Email
        Studio to automatically unsubscribe you from all the selected mailing
        lists!
      </LeftImage>
      <RightImage
        title="Private and Secure &nbsp; "
        image="google/security-letter.png"
        alt="Private and Secure"
      >
        Our infrastructure and application source code is audited and deeply
        tested by Bishop Fox, a global security auditing firm approved by
        Google, and are certified 100% compliant with Google API policies.
      </RightImage>
    </MainFeatures>
  );
};

export default Features;
